export const ColumnWidth = 190;
export const RowHeight = 140;
